<div *ngIf="isLoggedIn">
    <app-sidebar-nav></app-sidebar-nav>
</div>
<div *ngIf="!isLoggedIn">
    <app-login></app-login>
</div>
